export enum AlertType {
  Warning = 'warning',
  Error = 'error',
  Info = 'info',
  Success = 'success',
}
